import React from "react";
import Container from "../../../components/layouts/Container";
import { ContextLanguage } from "../../../context/Context.Language";
import FieldPhoneCountry from "../../../utils/PhoneNumber/usePhoneNumber";
import { TEXT_COUNTRY_CODE } from "../../../utils/useConstants";
import { STATE_CONSTANTS_LOGIN } from "../../../utils/useConstantState";

import {
  STYLE_ADDRESS_BG,
  STYLE_FLAG,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_NO_MB,
  STYLE_PREPARE_LANGUAGE,
  STYLE_UNSELECT_LANGUAGE,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";

const LoginCountryCode = ({ setContry, setTab, contry }) => {
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className={``}>
      <Container>
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
          <div className={`${STYLE_ADDRESS_BG}`}>
            <ProgramGoBack
              title={TEXT_COUNTRY_CODE[language]}
              classname="mb-2.5"
              onClick={() => {
                setTab(STATE_CONSTANTS_LOGIN.PHONE_NUMBER);
              }}
            />
            {FieldPhoneCountry?.map((row, index) => {
              return (
                <div key={`key-of-flas-${index}`}>
                  <div
                    onClick={() => {
                      localStorage.setItem("contry-code", JSON.stringify(row));
                      setContry(row);
                      setTab(STATE_CONSTANTS_LOGIN.PHONE_NUMBER);
                      document?.getElementById("first-div")?.scrollIntoView();
                      // setTimeout(() => {
                      //   document?.getElementById("phone_number")?.focus();
                      // }, 100);
                    }}
                    className=" cursor-pointer"
                  >
                    <div
                      className={` group flex gap-3 items-center text-gray-800 text-base leading-6w-full h-14 p-6 my-3 ${
                        contry?.value === row?.value
                          ? STYLE_PREPARE_LANGUAGE
                          : STYLE_UNSELECT_LANGUAGE
                      }`}
                    >
                      <img className={STYLE_FLAG} src={row?.image} />
                      <div className=" group-hover:underline w-fit break-all text-gray-800">
                        {row?.label} (+{row?.value})
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="pb-10"></div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default LoginCountryCode;
